// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"3d7e7daa","421":"07b32d13","422":"abba7b69","453":"0e59d84e","566":"48e00c41","629":"90528e1a","689":"9563ff05","837":"b9d6889f"}[chunkId] + ".chunk.js";
};